/* eslint-disable react-hooks/exhaustive-deps */
import TabNav from "components/TabNav";
import { useHasRole } from "contexts/AuthContext";
import AppealToCourtModal from "pages/accusedRequests/fragments/AppealToCourtModal";
import AddAppealCouncilLitigationDecisionModal from "pages/appealRequests/fragments/AddAppealCouncilLitigationDecisionModal";
import AddAppealLitigationDecisionModal from "pages/appealRequests/fragments/AddAppealLitigationDecisionModal";
import AppealCouncilLitigationCard from "pages/appealRequests/fragments/AppealCouncilLitigationCard";
import AppealLitigationCard from "pages/appealRequests/fragments/AppealLitigationCard";
import TerminateAppealLitigationModal from "pages/appealRequests/fragments/TerminateAppealLitigationModal";
import AssignedProsecutorHistory from "pages/complaintRequest/fragments/AssignedProsecutorHistory";
import ChargeDocumentCardAdvocate from "pages/complaintRequest/fragments/ChargeDocumentCardAdvocate";
import ComplaintDetailInfoCard from "pages/complaintRequest/fragments/ComplaintDetailInfoCard";
import DecisionCard from "pages/complaintRequest/fragments/DecisionCard";
import { useTranslation } from "contexts/i18nContext";
import { useToast } from "contexts/ToastContext";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  fetchAppealCouncilLitigationByAppealSummonId,
  fetchAppealLitigationByAppealSummonId,
  fetchComplaintById,
  fetchCourtAppealByComplaintId,
  fetchCourtAssignmentHistory,
  fetchInvestigationByComplaintId,
} from "services/prosecutorDecipilineService";
import {
  Complaints,
  CouncilLitigation,
  CourtAppeal,
  Investigation,
  Litigation,
} from "types";
import {
  COMPLIANT_STATUS,
  COURT_APPEAL_STATUS,
  INVESTIGATION_STATUS,
} from "utils/constantValues";
import { ROLES } from "utils/roles";
import AddCourtDailyHearingModal from "./fragments/AddCourtDailyHearingModal";
import CourtSummonCard from "./fragments/CourtSummonCard";

// const tabs = ["Detail Information", "Litigation", "Appeal"];

export default function SingleCourtAppeal() {
  const { uu_id } = useParams();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const canViewCompliantDetail = useHasRole([
    ROLES.INSPECTION_PROSECUTOR,
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
  ]);
  const canViewChargeDoc = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
    ROLES.INSPECTION_PROSECUTOR,
    ROLES.INSPECTION_REGISTRAR,
  ]);
  const canViewCourtAppeal = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
    ROLES.INSPECTION_PROSECUTOR,
    ROLES.INSPECTION_REGISTRAR,
    ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
    ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  ]);
  const canCreateInspectionDailyHearing = useHasRole([
    ROLES.INSPECTION_PROSECUTOR,
  ]);
  // const canCreateCouncilDailyHearing = useHasRole([
  //   ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  //   ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  // ]);
  const canCreateLitigationDecision = useHasRole([ROLES.INSPECTION_PROSECUTOR]);
  // const canCreateCouncilLitigationDecision = useHasRole([
  //   ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  //   ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  // ]);
  const canTerminateInspectionLitigation = useHasRole([
    ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canAppealToCourt = useHasRole([ROLES.INSPECTION_REGISTRAR]);

  const canViewAssignedHistory = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
  ]);

  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isDailyHearingOpen, setIsDailyHearingOpen] = useState(false);
  const [isLitigationDecisionOpen, setIsLitigationDecisionOpen] =
    useState(false);
  const [isCouncilLitigationDecisionOpen, setIsCouncilLitigationDecisionOpen] =
    useState(false);
  const [isTerminateOpen, setIsTerminateOpen] = useState(false);
  const [isAppealCourtOpen, setIsAppealCourtOpen] = useState(false);

  const [complaintData, setComplaintData] = useState<
    Complaints | Complaints[]
  >();
  const [investigationData, setInvestigationData] = useState<Investigation>();
  const [allInvestigationData, setAllInvestigationData] =
    useState<Investigation[]>();
  const [courtAppealData, setCourtAppealData] = useState<CourtAppeal>();
  const [appealLitigationData, setAppealLitigationData] =
    useState<Litigation[]>();
  const [appealCouncilLitigationData, setAppealCouncilLitigationData] =
    useState<CouncilLitigation[]>();
  const [assignmentHistoryData, setAssignmentHistoryData] = useState<any>();

  const tabs = [
    t("detailInformation"),
    courtAppealData?.status === COURT_APPEAL_STATUS.APPROVED && t("litigation"),
  ].filter((tab): tab is string => Boolean(tab));
  const [activeTab, setActiveTab] = useState<string>(tabs[0]);

  const isNotFoundError = (error: any) => {
    const status =
      error?.response?.status ?? error?.status ?? error?.request?.status;
    return status === 404;
  };

  useEffect(() => {
    if (tabs.length > 0 && !tabs.includes(activeTab)) {
      setActiveTab(tabs[0]);
    }
  }, [tabs, activeTab]);

  const loadInitialPageData = async () => {
    if (!uu_id) {
      setIsInitialLoading(false);
      return;
    }

    setIsInitialLoading(true);

    try {
      const complaintRes = await fetchComplaintById(uu_id);
      const latestComplaint = Array.isArray(complaintRes)
        ? complaintRes?.slice()?.reverse()[0]
        : complaintRes;
      setComplaintData(latestComplaint);

      try {
        const investigationRes = await fetchInvestigationByComplaintId(uu_id);
        if (investigationRes) {
          const sortedInvestigations = investigationRes?.slice()?.reverse();
          setAllInvestigationData(sortedInvestigations);
          setInvestigationData(
            Array.isArray(investigationRes)
              ? sortedInvestigations[0]
              : investigationRes,
          );
        } else {
          setAllInvestigationData(undefined);
          setInvestigationData(undefined);
        }
      } catch (err) {
        if (isNotFoundError(err)) {
          setAllInvestigationData(undefined);
          setInvestigationData(undefined);
        } else {
          throw err;
        }
      }

      const courtAppealRes = await fetchCourtAppealByComplaintId(uu_id).catch(
        (err) => {
          if (isNotFoundError(err)) return [] as CourtAppeal[];
          throw err;
        },
      );

      const latestCourtAppeal = courtAppealRes
        ?.slice()
        ?.reverse()
        ?.filter(
          (obj) => obj.discipline_complain?.toString() === uu_id?.toString(),
        )[0];

      setCourtAppealData(latestCourtAppeal);

      const appealLitigationRes = await fetchAppealLitigationByAppealSummonId(
        uu_id || "",
      ).catch((err) => {
        if (isNotFoundError(err)) return [] as Litigation[];
        throw err;
      });

      setAppealLitigationData(
        appealLitigationRes
          ?.slice()
          ?.reverse()
          ?.filter(
            (obj) =>
              obj.appealto_court?.toString() ===
              latestCourtAppeal?.id?.toString(),
          ),
      );

      const appealCouncilLitigationRes = latestCourtAppeal?.id
        ? await fetchAppealCouncilLitigationByAppealSummonId(
            latestCourtAppeal.id,
          ).catch((err) => {
            if (isNotFoundError(err)) return [] as CouncilLitigation[];
            throw err;
          })
        : [];

      setAppealCouncilLitigationData(
        appealCouncilLitigationRes
          ?.slice()
          ?.reverse()
          ?.filter(
            (obj) =>
              obj.appealto_court?.toString() ===
              latestCourtAppeal?.id?.toString(),
          ),
      );

      if (latestCourtAppeal?.id) {
        const assignmentHistoryRes = await fetchCourtAssignmentHistory().catch(
          (err) => {
            if (isNotFoundError(err)) return [];
            throw err;
          },
        );

        setAssignmentHistoryData(
          assignmentHistoryRes?.filter(
            (obj: any) =>
              obj?.summon_appeal?.toString() ===
              latestCourtAppeal?.id?.toString(),
          ),
        );
      } else {
        setAssignmentHistoryData([]);
      }
    } catch (err) {
      showToast(t("failedToLoadComplaint"), "error");
    } finally {
      setIsInitialLoading(false);
    }
  };

  const loadComplaints = useCallback(async () => {
    if (!uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchComplaintById(uu_id);
      setComplaintData(
        Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
      );
      // setError("");
    } catch (err) {
      // setError("Failed to load complaint.");
    } finally {
      // setLoading(false);
    }
  }, [uu_id]);

  const loadInvestigations = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchInvestigationByComplaintId(uu_id);
      if (resData) {
        setAllInvestigationData(resData?.slice()?.reverse());
        setInvestigationData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadCourtAppeal = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchCourtAppealByComplaintId(uu_id);
      if (resData) {
        setCourtAppealData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.discipline_complain?.toString() === uu_id?.toString(),
            )[0],
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadAppealLitigation = useCallback(async () => {
    if (!complaintData || !courtAppealData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");

      if (resData)
        setAppealLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.appealto_court?.toString() ===
                courtAppealData?.id?.toString(),
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, courtAppealData]);

  const loadAppealCouncilLitigation = useCallback(async () => {
    if (!courtAppealData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        courtAppealData?.id || "",
      );
      if (resData)
        setAppealCouncilLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.appealto_court?.toString() ===
                courtAppealData?.id?.toString(),
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [courtAppealData]);

  useEffect(() => {
    loadInitialPageData();
  }, [uu_id]);

  return (
    <div className="min-h-screen">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>💼</span>
        {t("courtAppealDetail")}
      </h1>

      <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        {activeTab === tabs[0] && (
          <div className="flex gap-4">
            {canAppealToCourt && !courtAppealData && (
              <button
                className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                type="submit"
                onClick={() => setIsAppealCourtOpen(true)}
              >
                {t("appealToCourt")}
              </button>
            )}
          </div>
        )}

        {activeTab === tabs[1] && (
          <div className="flex gap-4">
            {courtAppealData?.status === COURT_APPEAL_STATUS.APPROVED &&
              canCreateInspectionDailyHearing &&
              (!appealLitigationData ||
                (appealLitigationData &&
                  !appealLitigationData[0]?.is_final_verdict_given)) && (
                //     ||
                // (canCreateCouncilDailyHearing &&
                //   (!appealCouncilLitigationData ||
                //     (appealCouncilLitigationData &&
                //       !appealCouncilLitigationData[0]
                //         ?.is_final_verdict_given)))
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsDailyHearingOpen(true)}
                >
                  {t("addDailyHearing")}
                </button>
              )}

            {canCreateLitigationDecision &&
              appealLitigationData &&
              appealLitigationData[0]?.is_final_verdict_given &&
              !appealLitigationData[0]?.council_decision_summary &&
              !appealLitigationData[0]?.council_decision && (
                // councilLitigationData &&
                // councilLitigationData[0]?.is_final_verdict_given &&
                // (councilLitigationData[0]?.council_decision_summary ||
                //   councilLitigationData[0]?.council_decision) &&
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsLitigationDecisionOpen(true)}
                >
                  {t("addAppealLitigationDecision")}
                </button>
              )}

            {/* {canCreateCouncilLitigationDecision &&
              appealCouncilLitigationData &&
              appealCouncilLitigationData[0]?.is_final_verdict_given &&
              !appealCouncilLitigationData[0]?.council_decision_summary &&
              !appealCouncilLitigationData[0]?.council_decision && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsCouncilLitigationDecisionOpen(true)}
                >
                  Add Council Office Decision
                </button>
              )} */}

            {/* Inspection Litigation Termination */}
            {canTerminateInspectionLitigation &&
              appealLitigationData &&
              !appealLitigationData[0]?.termination_reason &&
              appealLitigationData[0]?.is_final_verdict_given && (
                <button
                  className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                  type="submit"
                  onClick={() => setIsTerminateOpen(true)}
                >
                  {t("terminate")}
                </button>
              )}
          </div>
        )}
      </div>

      <div className="relative">
        <div
          className={`grid grid-cols-1 lg:grid-cols-3 gap-4 ${
            isInitialLoading ? "pointer-events-none opacity-40" : ""
          }`}
        >
          {/* Detail Info */}
          {activeTab === tabs[0] && (
            <div className="lg:col-span-2 space-y-4">
              {canViewCourtAppeal &&
                courtAppealData &&
                complaintData &&
                !Array.isArray(complaintData) && (
                  <CourtSummonCard
                    compliantData={complaintData}
                    summonData={courtAppealData}
                    onSummonRefresh={loadCourtAppeal}
                    onComplaintsRefresh={loadComplaints}
                  />
                )}

              {investigationData &&
                complaintData &&
                !Array.isArray(complaintData) &&
                (canViewChargeDoc ||
                  investigationData?.status ===
                    INVESTIGATION_STATUS.FORWARDED_TO_COUNCIL ||
                  investigationData?.status ===
                    INVESTIGATION_STATUS.FORWARDED_TO_HEAD) && (
                  <ChargeDocumentCardAdvocate
                    investigationData={investigationData}
                    complaintData={complaintData}
                    onInvestigationRefresh={loadInvestigations}
                  />
                )}

              {canViewCompliantDetail &&
                complaintData &&
                !Array.isArray(complaintData) &&
                complaintData.status !== COMPLIANT_STATUS?.PENDING && (
                  <DecisionCard
                    complaintData={complaintData}
                    investigationData={investigationData}
                    allInvestigationData={allInvestigationData}
                    onInvestigationRefresh={loadInvestigations}
                  />
                )}

              {canViewCompliantDetail && (
                <ComplaintDetailInfoCard
                  complaintData={complaintData}
                  onComplaintsRefresh={loadComplaints}
                />
              )}
            </div>
          )}

          {/* Litigation */}
          {activeTab === tabs[1] && (
            <div className="lg:col-span-2 space-y-4">
              {appealCouncilLitigationData &&
                appealCouncilLitigationData?.length > 0 && (
                  <AppealCouncilLitigationCard
                    councilLitigationData={appealCouncilLitigationData}
                    onCouncilLitigationRefresh={loadAppealCouncilLitigation}
                  />
                )}

              {appealLitigationData && appealLitigationData?.length > 0 && (
                <AppealLitigationCard
                  fromCourt={true}
                  litigationData={appealLitigationData}
                  councilLitigationData={appealCouncilLitigationData || []}
                  onLitigationRefresh={loadAppealLitigation}
                  showForHead={true}
                />
              )}
            </div>
          )}

          {/* Sidebar */}
          <div className="space-y-4">
            {canViewAssignedHistory && assignmentHistoryData && (
              <AssignedProsecutorHistory
                data={assignmentHistoryData?.map((obj: any) => ({
                  ...obj,
                  assignedTo: obj?.assigned_prosecutor,
                  assignedDate: obj?.assigned_date,
                }))}
              />
            )}
          </div>
        </div>

        {isInitialLoading && (
          <div className="absolute inset-0 z-20 flex justify-center items-start pt-8 rounded-xl bg-gradient-to-br from-white/90 to-red-50/80 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-3 rounded-lg border border-red-100 bg-white/80 px-6 py-5 shadow-sm">
              <div className="h-10 w-10 border-4 border-red-600/80 border-t-transparent rounded-full animate-spin" />
              <p className="text-sm font-semibold text-gray-700">Loading...</p>
            </div>
          </div>
        )}
      </div>

      {/* /////////////////// MODAL FORMS ///////////////////  */}
      {complaintData &&
        !Array.isArray(complaintData) &&
        courtAppealData &&
        !Array.isArray(courtAppealData) && (
          <AddCourtDailyHearingModal
            isOpen={isDailyHearingOpen}
            setIsOpen={setIsDailyHearingOpen}
            summonData={courtAppealData}
            complaintData={complaintData}
            onLitigationRefresh={loadAppealLitigation}
            onCouncilLitigationRefresh={loadAppealCouncilLitigation}
          />
        )}

      {appealLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealLitigationDecisionModal
            fromCourt={true}
            isOpen={isLitigationDecisionOpen}
            setIsOpen={setIsLitigationDecisionOpen}
            complaintData={complaintData}
            litigationData={appealLitigationData[0]}
            onRefresh={loadAppealLitigation}
          />
        )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealCouncilLitigationDecisionModal
            isOpen={isCouncilLitigationDecisionOpen}
            setIsOpen={setIsCouncilLitigationDecisionOpen}
            complaintData={complaintData}
            councilLitigationData={appealCouncilLitigationData[0]}
            onRefresh={loadAppealCouncilLitigation}
          />
        )}

      {complaintData &&
        !Array.isArray(complaintData) &&
        appealLitigationData && (
          <TerminateAppealLitigationModal
            isOpen={isTerminateOpen}
            setIsOpen={setIsTerminateOpen}
            litigationData={appealLitigationData[0]}
            complaintData={complaintData}
            onRefresh={loadAppealLitigation}
          />
        )}

      {!courtAppealData && complaintData && !Array.isArray(complaintData) && (
        <AppealToCourtModal
          isOpen={isAppealCourtOpen}
          setIsOpen={setIsAppealCourtOpen}
          complaintData={complaintData}
          onComplaintRefresh={loadComplaints}
        />
      )}
    </div>
  );
}
